<template>
    <div>
        <div class="row">
            <div class="row">
                <div class="col-md-4">
                    <h2>{{ getTranslation('lbl_user_create_headline') }} </h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <form @submit.prevent="addUser">
                        <div class="form-group">
                            <label for="firstName">{{ getTranslation('lbl_user_first_name') }} *</label>
                            <input
                                    type="text"
                                    id="firstName"
                                    class="form-control"
                                    formControlName="firstName"
                                    v-model="user.firstName">
                        </div>
                        <div class="form-group">
                            <label for="lastName">{{ getTranslation('lbl_user_last_name') }}</label>
                            <input
                                    type="text"
                                    id="lastName"
                                    class="form-control"
                                    formControlName="lastName"
                                    v-model="user.lastName">
                        </div>
                        <div class="form-group">
                            <label for="username">{{ getTranslation('lbl_username') }} *</label>
                            <input
                                    type="text"
                                    id="username"
                                    class="form-control"
                                    formControlName="username"
                                    v-model="user.username">
                        </div>
                        <div class="form-group">
                            <label for="email">{{ getTranslation('lbl_user_mail') }} *</label>
                            <input
                                    type="email"
                                    id="email"
                                    class="form-control"
                                    formControlName="email"
                                    v-model="user.email"
                                    >
                        </div>
                        <div class="form-group">
                            <label for="password">{{ getTranslation('lbl_password') }} *</label>
                            <input
                                    type="password"
                                    id="password"
                                    class="form-control"
                                    autocomplete="new-password"
                                    formControlName="password"
                                    v-model="user.password">
                        </div>
                        <div class="form-group">
                            <label for="langSelector">{{ getTranslation('lbl_language') }}</label>
                            <div class="dropdown" v-on-clickaway="dropClose" :class="{ open: isOpened }"
                                 id="langSelector">
                                <button class="dropdown-toggle form-control" @click.prevent="dropToggle" type="button" >
                                    {{ langString }}
                                    <span class="caret"></span></a>
                                </button>
                                <ul class="dropdown-menu" @click="dropToggle">
                                    <li><a href="#" @click.prevent="setNewUserLanguage('de');">{{
                                        getTranslation('lbl_deutsch') }}</a></li>
                                    <li><a href="#" @click.prevent="setNewUserLanguage('en');">{{
                                        getTranslation('lbl_english') }}</a></li>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="divider"></div>
                        <button class="btn btn-primary" type="submit" >
                            {{ getTranslation('app_lbl_action_user_create') }}
                        </button>
                        <button class="btn pull-right" type="button" @click.prevent="goBack()">
                            {{ getTranslation('app_lbl_action_cancel') }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mainEventBus } from '../../../../main';
    import {translationMixin} from '../../../../Banet/mixins/translationMixin.js';
    import { userMixin } from '../../../../Banet/mixins/userMixin.js';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        mixins: [ translationMixin, userMixin, dropdownMixin, clickaway ],
        created: function(){
            this.getUsers();
        },
        sockets:{
            usersChanged: function(){
                if (this.$route.params.id) {
                    this.$route.meta.activeTab = 3;  // setting active tab when adding user and going back on client-page
                    this.$router.push(`/client/${this.$route.params.id}`);
                } else {
                    this.goBack();
                }
            },
           sameUserExist: function(sameUser) {
              if (sameUser != null) {
                 console.log('sameUserExist', sameUser);
                 if(sameUser.username === this.user.username){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_username_exists' } );
                 }
                 if(sameUser.email === this.user.email){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_email_used' } );
                 }
              } else {
                 this.setUser();
              }
           }
        },
        data: function () {
            return {
                user: {
                    firstName: '',
                    lastName: '',
                    username: '',
                    email: '',
                    password: '',
                    role: '',
                    language: 'de'
                },
                required: [
                    { name: 'firstName', found: false },
                   { name: 'username', found: false },
                    { name: 'email', found: false },
                    { name: 'password', found: false }
                ]
            }
        },
        methods: {
           setNewUserLanguage: function(lang){
              this.user.language = lang;
           },
            gotoLogin: function(){
//                this.$router.push('/login');
            },
            addUser: function(){
               if(this.isClient) {
                  this.user.role = 'client-admin';
               } else if(this.isAdmin) {
                  this.user.role = 'admin';
               }
//                for (var i in this.user) {
//                   this.user[i] = this.user[i].trim();
//                    if(!this.user[i]) {
////                        this.$store.dispatch('setErrors', 'All fields are required');
//                        mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_all_required' } );
//                        return false;
//                    }
//                }

               console.log('ADD USER',  this.user);

               for (let i in this.user) {
                  if(typeof(this.user[i]) === 'string') {
                     this.user[i] = this.user[i].trim();
                  }
                  for (let j in this.required) {
//                        this.required[j].found = false;
                     if (i === this.required[j].name) {
                        if(this.user[i] !== '') {
                           this.required[j].found = true;
                        }
                     }
                  }
               }
               for (let i in this.required) {
                  if (this.required[i].found == false) {
                     mainEventBus.$emit( 'alert', { type:'warning', msg:'error_' + this.required[i].name + '_required' } );
                     for (let i in this.required) {
                        this.required[i].found = false;
                     }
                     return false;
                  }
               }

                if(this.findInUsers('email', this.user.email)){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_email_used' } );
                    return false;
                }
                if(this.user.username && this.findInUsers('username', this.user.username)){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_username_exists' } );
                    return false;
                }
                if (this.$route.params.id) {
                    this.user.role = 'client-admin';
                    this.user.client = this.$route.params.id;
                }
                this.user.crud = '1';
               this.$socket.emit('getSameUserExist', this.user);
            },
            setUser(){
               this.$socket.emit('userCreate', this.user);
            },
            setRole: function(role){
//                this.user.role = role;
            },
            goBack: function(){
                if (this.$route.params.id ||
                    (this.$store.getters.getRole === 'user' || this.$store.getters.getRole === 'client')) {
                    this.$route.meta.isClientAdmin = true;
                } else {
                    this.$route.meta.isClientAdmin = false;
                }
                const redirectURL = (this.$route.meta.isClientAdmin) ? `/client/${this.$route.params.id}` : '/users';
                this.$router.push(redirectURL);
            },
        }
    }
</script>


<style scoped>
    .dropdown {
        width: 100%;
    }
    .dropdown .caret {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .dropdown .dropdown-toggle {
        width: 100%;
        text-align: left;
    }

    .dropdown-menu {
        width: 100%;
        margin-top: -1px;
    }
</style>


// WEBPACK FOOTER //
// UserCreate.vue?a1889606